import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from '../assets/images/Logo.png';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navItems = [
    { path: '/', label: 'ہوم' },
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          {/* Navigation Links - Left Side */}
          <div className="nav-links-wrapper">
            <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className={location.pathname === item.path ? 'active' : ''}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li className="nav-cta-mobile">
                <Link to="/contact-us" className="btn btn-primary" onClick={() => window.scrollTo(0, 0)}>
                  رابطہ کریں
                </Link>
              </li>
            </ul>
            <Link to="/contact-us" className="btn btn-primary nav-cta-desktop" onClick={() => window.scrollTo(0, 0)}>
              رابطہ کریں
            </Link>
          </div>

          {/* Logo - Right Side */}
          <Link to="/" className="logo" onClick={() => window.scrollTo(0, 0)}>
            <img src={Logo} alt="عمل ایپ" className="logo-img" />
          </Link>

          {/* Mobile Menu Toggle */}
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
